import { ApolloError } from "@apollo/client";

/**
 * Formats a mapping-preview failure for display in the result column.
 *
 * GraphQL errors carry the backend message (including the JSON5 parse position
 * within the template) plus their document locations; both are surfaced so the
 * admin can pinpoint the problem. Non-Apollo errors fall back to their message,
 * and anything non-`Error` becomes a generic string.
 *
 * @param error The thrown/rejected value from the preview query.
 * @returns A human-readable, multi-line error string.
 */
export const formatPreviewError = (error: unknown): string => {
  if (error instanceof ApolloError && error.graphQLErrors.length > 0) {
    return error.graphQLErrors
      .map((gqlError) => {
        const locations = (gqlError.locations ?? [])
          .map((loc) => `line ${loc.line}, column ${loc.column}`)
          .join("; ");
        return locations.length > 0
          ? `${gqlError.message}\n  at ${locations}`
          : gqlError.message;
      })
      .join("\n\n");
  }
  return error instanceof Error ? error.message : "Unknown error";
};
